
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiShipFishing as ObiShipFishingElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-ship-fishing.js';
 
 
 

 
 export const ObiShipFishing = createComponent({
   react: React,
   tagName: 'obi-ship-fishing',
   elementClass: ObiShipFishingElement,
   events: {
     
   }
  });
 
 